<template>
  <div class="select-form" layout="column">
    <div class="mb-x1" v-if="label"><i class="mdi" v-if="icon" :class="['mdi-' + icon]"></i>{{ label }}</div>
    <el-select
      v-model="selectedValue"
      :placeholder="placeholder"
      :clearable="clearable"
      @change="onChange"
      :size="size"
      :disabled="disabled"
      :multiple="multiple"
    >
      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
    </el-select>
  </div>
</template>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.mdi {
  width: 20px;
  height: 20px;
  margin-right: $spacing-unit;
}
</style>
<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  props: {
    value: {
      type: [String, Number, Array] as PropType<string | number | unknown[] | null>,
      default: undefined
    },
    options: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    multiple: {
      type: Boolean,
      default: false
    },
    onChange: {
      type: Function,
      default: () => {
        return
      }
    },
    clearable: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedValue: this.value
    }
  },
  watch: {
    value() {
      this.selectedValue = this.value
    }
  }
})
</script>
